import React, { useContext, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { handleTimeChange } from '@mummssoftware/utils/visitUtils';
import { ErrorText } from '@mummssoftware/common-ui/style';
import {
  HCPCSGlobalContext,
  SET_HCPCS_DURATION,
  SET_HCPCS_ERROR,
  RECORD_DATA,
} from '@mummssoftware/global-context/HCPCSGlobalContext';
import { TimerDiv, EditTimeDiv } from '../Timer/styledDiv';
import { useStyles } from '../Timer/style';
import defaults from '../../../../translations/en.json';

type HCPCSDurationProps = {
  hcpcsChoice: mumms.HCPCSMenuItem | null;
};

export const HCPCSDuration = ({ hcpcsChoice }: HCPCSDurationProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const { dispatchHCPCS, hcpcsError, hcpcsDuration } = useContext(
    HCPCSGlobalContext,
  );

  const initDuration =
    hcpcsDuration && hcpcsChoice && hcpcsDuration[hcpcsChoice.key];

  const [duration, setDuration] = useState<number>(initDuration || 0);

  useEffect(() => {
    if (initDuration) {
      setDuration(initDuration);
    }
  }, [initDuration]);

  // error if no duration entered
  useEffect(() => {
    if (!hcpcsError) {
      if (Number(duration) === 0) {
        dispatchHCPCS({
          type: SET_HCPCS_ERROR,
          payload: true,
        });
      } else {
        dispatchHCPCS({
          type: SET_HCPCS_ERROR,
          payload: false,
        });
      }
    }
  }, [duration, hcpcsError]);

  const minMinute =
    hcpcsChoice && hcpcsChoice.rules
      ? Number(Object.keys(hcpcsChoice.rules)[0])
      : 0;
  const maxMinute =
    hcpcsChoice && hcpcsChoice.maxTime ? hcpcsChoice.maxTime : null;

  const minTimeError = duration > 0 && duration < minMinute;
  const maxTimeError = duration > 0 && maxMinute && duration > maxMinute;

  const onMinChange = (event: any) => {
    const targetValue = event.target.value;
    setDuration(targetValue);
    dispatchHCPCS({
      type: RECORD_DATA,
      payload: true,
    });
  };
  const handleMinChange = handleTimeChange(onMinChange);

  const onKeyDown = (e: any) => {
    // on Enter
    if (e.keyCode === 13) {
      onMinSave(e);
    }
  };

  const onMinSave = (event: any) => {
    const targetValue = event.target.value;
    if (
      hcpcsChoice &&
      hcpcsChoice.rules &&
      Object.keys(hcpcsChoice.rules).length
    ) {
      const hcpcsMins = Object.keys(hcpcsChoice.rules);
      const minDuration = Number(hcpcsMins[0]);
      if (targetValue >= minDuration) {
        // only dispatch if rule is respected
        dispatchHCPCS({
          type: SET_HCPCS_DURATION,
          payload: { key: hcpcsChoice.key, duration: targetValue },
        });
        if (hcpcsError) {
          dispatchHCPCS({
            type: SET_HCPCS_ERROR,
            payload: false,
          });
        }
      } else {
        dispatchHCPCS({
          type: SET_HCPCS_DURATION,
          payload: { key: hcpcsChoice.key, duration: null },
        });
        if (targetValue > 0 && targetValue < minMinute) {
          dispatchHCPCS({
            type: SET_HCPCS_ERROR,
            payload: true,
          });
        }
      }
    }
  };

  const inputProps = {
    classes: {
      input: classes.input,
      root: minTimeError ? classes.outlinedError : classes.outlined,
    },
  };

  return (
    <EditTimeDiv className="edit-hcpcs-time-div">
      <FormHelperText id="component-helper-text">
        {duration ? defaults.duration : defaults.enterDuration}
      </FormHelperText>

      <TimerDiv edit>
        <TextField
          label="MM"
          id="min-edit"
          variant="outlined"
          value={duration}
          InputProps={inputProps}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ maxLength: 4 }}
          onChange={handleMinChange}
          onKeyDown={onKeyDown}
          onBlur={onMinSave}
          InputLabelProps={{
            shrink: true,
            classes: { root: classes.labelInput },
          }}
        />
      </TimerDiv>

      {minTimeError && (
        <ErrorText>
          {intl.formatMessage(defaults.errorHCPCS, {
            minMinutes: minMinute,
          })}
        </ErrorText>
      )}
      {maxTimeError && (
        <ErrorText>
          {intl.formatMessage(defaults.errorMaxHCPCS, {
            maxMinutes: maxMinute,
          })}
        </ErrorText>
      )}
    </EditTimeDiv>
  );
};

export default HCPCSDuration;
